<template>
  <BaseWeb :logo-img="logoPhoto"
           :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
           class="many_recruit_btn" :download-path="downloadPath" :one-word="oneWord" :tow-word="towWord"></BaseWeb>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "newNmg",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/newNmg/logo.png'),
      appPhotoArr:[
        {id:1,photo:require('../assets/newNmg/one.png')},
        {id:2,photo:require('../assets/newNmg/tow.png')},
        {id:3,photo:require('../assets/newNmg/three.png')},
        {id:4,photo:require('../assets/newNmg/four.png')},
      ],
      appName:'兼职檽米狗',
      companyName:'厦门热摆摆网络科技有限公司',
      icpNum:'闽ICP备18019105号-1',
      downloadPath:'http://apk.hotbuybuy.com/cmjz_oppo_100.apk',
      oneWord:'手机兼职赚钱软件就选兼职糯米狗！',
      towWord:'兼职糯米狗是一款手机兼职赚钱App，玩手机兼职做赚钱任务，轻松赚到生活费，糯米狗赚钱兼职平台，帮你找到新的赚钱方式。丰富的任务类型和海量任务，就在糯米狗。',
    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(254,200,40);
}
</style>



// WEBPACK FOOTER //
// src/components/newNmg.vue